import { render, staticRenderFns } from "./Tic.container.vue?vue&type=template&id=d6889afa&scoped=true&"
import script from "./Tic.container.vue?vue&type=script&lang=js&"
export * from "./Tic.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6889afa",
  null
  
)

export default component.exports